import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fieldState } from "@/lib/content";
import { t } from "@/lib/i18n";
import Reveal from "@/components/Reveal";
import VisitCard from "@/components/VisitCard";
import { path } from "@/lib/routes";

const KEYS = ["address", "opening_hours", "entrance_parking", "visit_arrangement"];

export default function VisitSummary({ content, isPreview }) {
  const fields = KEYS.map((k) => [k, fieldState(content?.visit?.[k], isPreview)]).filter(([, s]) => s.show);
  if (!fields.length) return null;
  return (
    <section className="safe-x max-w-7xl mx-auto py-20 sm:py-28" data-testid="home-visit-summary">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
        <div>
          <p className="eyebrow mb-4">{t("home.visitEyebrow")}</p>
          <h2 className="text-4xl sm:text-5xl font-semibold text-forest max-w-xl leading-[1.08]">{t("home.visitTitle")}</h2>
        </div>
        <Link to={path("ziyaret")} className="inline-flex items-center gap-2 min-h-[44px] font-semibold text-forest underline-offset-4 hover:underline" data-testid="home-visit-all-link">
          {t("home.visitLink")} <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </Reveal>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {fields.map(([k, s], i) => (
          <Reveal key={k} delay={i * 70}><VisitCard fieldKey={k} state={s} /></Reveal>
        ))}
      </div>
    </section>
  );
}
